import { RedoOutlined } from '@ant-design/icons';
import { EllipsisSpan, Paging, Table, usePaging, useUpdate, CustomFilter, MultiSelect,Select } from '@maxtropy/components';
import { Button, Form, Input } from 'antd';
import { FC, useEffect, useState } from 'react';
import styles from './index.module.scss';
import { Link } from 'react-router-dom';
import { BatchRuleGroupPageRequest } from '../../../../api/ruleGroup';
import { IotProtocolType } from '@/shared/types';
import { RuleGroupList } from '@/pages/Device/BatchBindRuleGroup/SelectRuleGroup/types';
import { apiV2RuleRulePagePost ,V2RuleRulePagePostResponse,apiV2RuleGroupDeviceAllRuleGroupPost} from '@maxtropy/tody-mgmt-apis-v2';
import { AlarmStatus, alarmStatusDisplay, alarmStatusOptions } from './types';

export type RuleItem = Exclude<V2RuleRulePagePostResponse['list'], undefined>[number];

const columns = [
  {
    title: '规则名称',
    dataIndex: 'name',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '规则状态',
    dataIndex: 'status',
    ellipsis: { showTitle: true },
    render: (v: AlarmStatus) => <EllipsisSpan value={alarmStatusDisplay[v]} />,
  },
  {
    title: '规则编号',
    dataIndex: 'code',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '所属规则组',
    dataIndex: 'ruleGroupName',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  // {
  //   title: '报警标签',
  //   dataIndex: 'label',
  //   ellipsis: { showTitle: true },
  //   render: (v: string) => <EllipsisSpan value={v} />,
  // },
];

export interface SelectRuleGroupModalChildrenProps {
  value?: RuleGroupList[];
  onChange?: (val: RuleGroupList[]) => void;
  rootMcid?: string;
  deviceTypeId?: number;
  iotProtocol?: IotProtocolType;
  objectModalType?: number;
  unBind?: () => void;
}

type SearchParams = Omit<BatchRuleGroupPageRequest, 'rootMcid' | 'iotProtocol' | 'size' | 'page'>;

const SelectRuleGroupModalChildren: FC<SelectRuleGroupModalChildrenProps> = ({
  value,
  onChange,
  rootMcid,
  deviceTypeId,
  iotProtocol,
  objectModalType,
}) => {
  const [form] = Form.useForm();

  const pagingInfo = usePaging(100);
  const { pageOffset, pageSize, setTotalCount, setPageOffset } = pagingInfo;

  const [searchParams, setSearchParams] = useState<SearchParams>();
  const [ruleGroups, setRuleGroups] = useState<RuleGroupList[]>([]);
  const [updateState, updateFn] = useUpdate();

  const [loading, setLoading] = useState<boolean>(false);
  const [nameOptions, setNameOptions] = useState<RuleGroupList[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  useEffect(() => {
    if (value) {
      setSelectedRowKeys(value.map(i => i.id!));
    }
  }, [value]);

  useEffect(() => {
    if (rootMcid && iotProtocol !== undefined) {
      setLoading(true);
      apiV2RuleRulePagePost({
        ...searchParams,
        rootMcid,
        typeId: deviceTypeId,
        // iotProtocol,
        // physicalModelId: objectModalType,
        page: pageOffset,
        size: pageSize,
      }).then(res => {
        setLoading(false);
        if (res) {
          setTotalCount(res.total ?? 0);
          res.list && setRuleGroups(res.list);
        }
      }).finally(()=> setLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rootMcid, iotProtocol, pageOffset, pageSize, searchParams, setTotalCount, updateState]);

  useEffect(() => {
    if (rootMcid && iotProtocol !== undefined) {
      apiV2RuleGroupDeviceAllRuleGroupPost({
        nameOrCode:searchParams?.codeOrNameLike,
        rootMcid,
        deviceTypeId,
        iotProtocol,
        physicalModelId: objectModalType,
      }).then(res => {
        if (res) {
          res.list && setNameOptions(res.list);
        }
      });
    }
  }, []);

  const onFinish = (value: SearchParams) => {
    setSearchParams(value);
    setPageOffset(1);
  };

  const onReset = () => {
    setSearchParams({});
    form.setFieldsValue({
      codeOrNameLike: undefined,
      ruleGroupIdList: undefined,
    });
    setPageOffset(1);
  };

    const rowSelection = {
    preserveSelectedRowKeys: true,
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: RuleGroupList[]) => {
      setSelectedRowKeys(selectedRowKeys);
      onChange?.(selectedRows);
    },
  };

  const filters = (
    <CustomFilter form={form} colSpan={8} onFinish={onFinish} onReset={onReset}>
      <Form.Item name="codeOrNameLike" label="编号/名称">
        <Input placeholder="请输入编号或名称查询" />
      </Form.Item>
      <Form.Item label="规则组名称" name="ruleGroupIdList">
        <MultiSelect
          placeholder="请选择"
          showSearch
          options={nameOptions.map(i => ({ label: i.name, value: i.id }))}
        ></MultiSelect>
      </Form.Item>
     <Form.Item label="报警状态" name="status">
        <Select placeholder="请选择" allowClear options={alarmStatusOptions} />
      </Form.Item>
    </CustomFilter>
  );

  return (
    <>
      {filters}
      <div className={styles.tips}>
        <span>
          <Button type="link" onClick={()=>{
            setSelectedRowKeys([]);
            onChange?.([])
          }}>
            全部移除
          </Button>
          <Button type="link">
            <Link to={`/device/rule/list/group/create`} target="_blank">
              新建规则组
            </Link>
          </Button>
          <Button style={{ padding: 0, paddingLeft: 2, paddingRight: 2, height: 24 }} onClick={updateFn} type="link">
            <div>
              <RedoOutlined rotate={270} />
              刷新页面
            </div>
          </Button>
        </span>
      </div>
      {iotProtocol === IotProtocolType.MOCKINGBIRD && (
        <div className={styles.tip}>
          提示：新增或解绑设备的报警规则组信息，需要前往网关管理页面，进行配置下发后，才可以生效。
        </div>
      )}
      <Table
        loading={loading}
        sticky
        scroll={{ y: 300 }}
        rowKey="id"
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        columns={columns}
        dataSource={ruleGroups}
      />
      <Paging pagingInfo={pagingInfo} />
    </>
  );
};

export default SelectRuleGroupModalChildren;
